<modal-layout-right (close)="close()">
    <ng-container ngProjectAs="[modalTitle]">
        <p class="w-12 s1 left p-l-3-x p-l-3-l p-t-2">{{'Filters & Sort' | translate}}</p>
    </ng-container>

    <div modalBody>
        <!-- sort listing -->
        <div class="b-b b-col-4">
            <div class="p-b-4-s p-b-4-m p-t-6-s p-t-6-m p-r-6 p-l-8 p-l-4-s p-l-4-m">
                <p class="h4 m-t-4-x m-t-4-l m-b-4">{{'Sort by' | translate}}</p>
                <ng-container *ngComponentOutlet="sortOutlet.component; inputs: $any(sortOutlet).inputs;" />
            </div>
        </div>
        <!-- filters -->
        @for (filter of getFilterOptions(); track $index) {
        <div class="b-col-4 m-t-4-x m-t-4-l p-b-4-s p-b-4-m p-t-6-s p-t-6-m p-r-6 p-l-8 p-l-4-s p-l-4-m"
             [ngClass]="{'b-b': !$last}">
            <ng-container
                          *ngComponentOutlet="getFilterOutlet(filter).component; inputs: $any(getFilterOutlet(filter)).inputs" />
        </div>
        }
    </div>

    <!-- filter buttons -->
    <div modalFooter
         class="w-12 flex flex-justify-center flex-column p-t-9 p-r-8 p-b-9 p-l-8 p-t-5-s p-t-5-m p-r-4-s p-r-4-m p-b-5-s p-b-5-m p-l-4-s p-l-4-m">
        <!-- clear -->
        <div class="w-12 flex flex-justify-center"
             [style.gap.px]="8">
            <button class="button-1 w-5 w-6-s p-r-3-s p-l-3-s"
                    (click)="clearFilters()">
                <span class="button__body">{{'Clear All Filters' | translate}}</span>
            </button>

            <!-- close -->
            <button class="button w-5 w-6-s"
                    (click)="close()"
                    modalClose>
                <span class="button__body">{{'Apply Filters' | translate}}</span>
            </button>
        </div>

        @if(activeFiltersCount && activeFiltersCount > 0) {
        <div class="w-12 flex flex-wrap p-t-1 p-b-1 p-l-2"
             [class.m-t-9]="filtersWithSelection && filtersWithSelection.length > 0"
             [style.gap.px]="8">
            @for (selectedFilter of filtersWithSelection; track $index) {
            @if(['ac-filter', 'ac-filter-range', 'attribute-option',
            'attribute-range'].includes(selectedFilter.filterType) ||
            ['stock', 'attribute-option'].includes($any(selectedFilter).config?.type)) {
            @switch($any(selectedFilter).filterType) {
            @default {
            @for(optionId of $any(selectedFilter).selection; track $index) {
            <button class="no-wrap flex flex-middle bg-col-51 p-t-1 p-b-1 p-l-2 p-r-2"
                    [style.border-radius.px]="4">
                <span class="inline-block c1 no-wrap">
                    {{$any(selectedFilter).getOptionLabel(optionId)}}
                </span>
                <i class="inline-flex icon-close m-l-2 cursor-pointer"
                   [style.font-size.px]="7"
                   (click)="$any(selectedFilter).unselect(optionId)"></i>
            </button>
            }
            }
            @case ('attribute-range') {
            <button class="no-wrap flex flex-middle bg-col-51 p-t-1 p-b-1 p-l-2 p-r-2"
                    [style.border-radius.px]="4">
                <span class="inline-block c1 no-wrap">
                    @if(asRangeFilter(selectedFilter).selection?.min) {
                    <price [value]="asRangeFilter(selectedFilter).selection!.min"></price>
                    }
                    -
                    @if(asRangeFilter(selectedFilter).selection?.max) {
                    <price [value]="asRangeFilter(selectedFilter).selection!.max"></price>
                    }
                </span>
                <i class="inline-flex icon-close m-l-2 cursor-pointer"
                   [style.font-size.px]="7"
                   (click)="asRangeFilter(selectedFilter).reset()"></i>
            </button>
            }
            @case ('ac-filter') {
            <button class="no-wrap flex flex-middle bg-col-51 p-t-1 p-b-1 p-l-2 p-r-2"
                    [style.border-radius.px]="4">
                <span class="inline-block c1 no-wrap">
                    {{asAcFilter(selectedFilter).value}}
                </span>
                <i class="inline-flex icon-close m-l-2 cursor-pointer"
                   [style.font-size.px]="7"
                   (click)="asAcFilter(selectedFilter).unselect(asAcFilter(selectedFilter).filterProp,asAcFilter(selectedFilter).optionProp)"></i>
            </button>
            }
            @case ('ac-filter-range') {
            <button class="no-wrap flex flex-middle bg-col-51 p-t-1 p-b-1 p-l-2 p-r-2"
                    [style.border-radius.px]="4">
                <span class="inline-block c1 no-wrap">
                    <price [value]="asAcFilterRange(selectedFilter).from"></price>
                    -
                    <price [value]="asAcFilterRange(selectedFilter).to"></price>
                </span>
                <i class="inline-flex icon-close m-l-2 cursor-pointer"
                   [style.font-size.px]="7"
                   (click)="asAcFilterRange(selectedFilter).unselect()"></i>
            </button>
            }
            }
            }
            }
        </div>
        }
    </div>
</modal-layout-right>